export const Support = {
  
  index: function() {
      var barOffset = $('.main.clearfix').outerHeight(true) - $('.main.clearfix').outerHeight() + $('.navbar-fixed-top').outerHeight();
      if ($('#answer-section').length > 0) {
        window.scrollTo(0, $('#answer-section').offset().top - barOffset);
      }

      var offset = $('#submit-question').offset().top - barOffset;
      $('#submit-question').offset({ top: offset });
      var offset = $('#faq').offset().top - barOffset;
      $('#faq').offset({ top: offset });

      jQuery('.faq .faq-question').on('click', function (e) {
        jQuery(this).toggleClass('active');
        e.preventDefault();
        jQuery(this).closest('.faq-content').find('.faq-answer').toggleClass('hidden');
        jQuery(this).closest('.faq-content').find('i').toggleClass('faq-arrow-down');

        return false;
      })

      $('#videos-container').length>0 ? ActionJS.Support._initVideoList() : ActionJS.Support._initVideo();
	},
	
	show_support_request: function (requestId, status) {
    jQuery('.support-request-form').each(function () {
      var formContainer = jQuery(this);
      SmartME.setLoadingIndicator(formContainer);
      formContainer.load(formContainer.attr('data-url'), function () {
        if (formContainer.find('.adalia-form').length > 0) {
          AdaliaForm.init(formContainer);
        }
      });
    });
  },

  _support_form: function () {
    jQuery('.support-request-form').each(function () {
      var formContainer = jQuery(this);
      SmartME.setLoadingIndicator(formContainer);
      formContainer.load(formContainer.attr('data-url'), function () {
        if (formContainer.find('.adalia-form').length > 0) {
          AdaliaForm.init(formContainer);
        }
      });
    });
  },

  _initVideo: function() {
    jQuery('.video-box').on('click', function () {
      var dialog = jQuery('#modal-dialog');
      var dialogContent = ""
      if (I18n.locale === "fr") {
        dialogContent = "<div class='embed-STv5d5nSmE'></div><script type='text/javascript' src='https://video.adalia.fi/embed/s/STv5d5nSmE?width=responsive'></script>";
      } else {
        dialogContent = "<div class='embed-STu45ahI89'></div><script type='text/javascript' src='https://video.adalia.fi/embed/s/STu45ahI89?width=responsive'></script>";
      }

      dialog.find('.modal-dialog').addClass('modal-lg')
      dialog.find('.modal-body').html(dialogContent);
      dialog.find('.modal-footer').remove();
      dialog.modal();

      dialog.find('.modal-header .close').on('click', function () {
        jQuery(this).closest('#modal-dialog').find('.modal-body').html("");
      })

      return false;
    });
  },
  _initVideoList: function() {
    jQuery('.video-box').on('click', function(){
      var dialog = jQuery('#modal-dialog');
      var dialogContent = ''
      var str_id = jQuery(this).data('str-id')
      dialogContent = "<div class='embed-"+ str_id + "'></div><script type='text/javascript' src='https://video.adalia.fi/embed/s/" + str_id + "?width=responsive'></script>"
    
      console.log(dialogContent, 'content')
      console.log(dialog, 'dialog')
      dialog.find('.modal-dialog').addClass('modal-lg')
      dialog.find('.modal-body').html(dialogContent);
      dialog.find('.modal-footer').remove();
      dialog.modal();

      dialog.find('.modal-header .close').on('click', function () {
        jQuery(this).closest('#modal-dialog').find('.modal-body').html("");
      })

      return false;
    })
  }
};